import React from "react";

import ConvitesBoard from "../components/Board/ConvitesBoard";
import Drawer from "../components/Drawer";
import Layout from "~/components/UI/Layout/Layout";
import { LoadingTopBar } from "~/components/UI/LoadingTopBar";

import { BOARD_TYPES } from "../constants";
import { MarketingFiltersContext } from "../filters";
import useMarketingBoard from "../useMarketingBoard";

export const ConvitesDomain = () => {
  // Month kept across refreshes (key 'marketing.convites').
  // Always load fresh data for Convites, skip cache loading.
  const {
    isLoading,
    setIsLoading,
    date,
    setDate,
    filtersContext,
  } = useMarketingBoard(BOARD_TYPES.CONVITES, { useCache: false });

  return (
    <div>
      <LoadingTopBar isActive={isLoading} />
      <Layout>
        <MarketingFiltersContext.Provider value={filtersContext}>
          <ConvitesBoard 
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            date={date}
            setDate={setDate}
          />
        </MarketingFiltersContext.Provider>
        <Drawer />
      </Layout>
    </div>
  );
};

export default ConvitesDomain;
